import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  dependency: PropTypes.arrayOf(
    PropTypes.shape({
      depends: PropTypes.shape({
        epicId: PropTypes.string.isRequired,
      }).isRequired,
    }),
  ),

  data: PropTypes.shape({
    dependency: PropTypes.arrayOf(
      PropTypes.shape({
        depends: PropTypes.shape({
          epicId: PropTypes.string.isRequired,
        }).isRequired,
      }),
    ),
  }).isRequired,
  projectKey: PropTypes.string.isRequired,
};

const defaultProps = {
  dependency: [],
};

const DependenciesRenderer = ({ data, projectKey }) => {
  if (data.dependency && data.dependency.length > 0) {
    return data.dependency.map((d, i) => {
      const dependsEpicId = d?.depends?.epicId;

      if (dependsEpicId === null || dependsEpicId === undefined) {
        return null;
      }

      return (
        <span className="link" key={`${data.id}-${i}`}>
          {`${projectKey}-`}
          {dependsEpicId.toString().padStart(3, '0')}
          {`${data.dependency.length > i + 1 ? ', ' : ''}`}
        </span>
      );
    });
  }

  return null;
};

DependenciesRenderer.defaultProps = defaultProps;
DependenciesRenderer.propTypes = propTypes;
export default DependenciesRenderer;
